import SectionHeading from './SectionHeading';
import { appPlatforms } from '@/mocks/home';

export default function AppGuide() {
  return (
    <section id="app" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="App Download"
          title="APP 下载与安装指引"
          desc="不同设备获取方式不一样。下面按安卓、苹果和电脑端分别说明，重点是核对来源、按系统提示放行，避免安装到来源不明的程序。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 lg:grid-cols-3">
          {appPlatforms.map((p) => (
            <article key={p.platform} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">{p.platform}</h3>
                  <p className="text-xs text-foreground-500">{p.method}</p>
                </div>
              </div>
              <ul className="mt-4 space-y-2.5 border-t border-background-200 pt-4">
                {p.points.map((pt) => (
                  <li key={pt} className="flex gap-2 text-sm leading-relaxed text-foreground-600">
                    <i className="ri-check-line mt-0.5 shrink-0 text-secondary-600"></i>
                    <span>{pt}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="mt-6 flex flex-col gap-4 rounded-lg border border-accent-200 bg-accent-50 p-5 sm:flex-row sm:items-center">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-background-50">
            <i className="ri-alert-line text-xl"></i>
          </span>
          <p className="text-sm leading-relaxed text-accent-900">
            <strong className="font-semibold">提醒：</strong>
            不要从陌生群聊、来历不明的网盘或「破解版」站点下载安装包。这类文件常被二次打包，可能带来隐私与设备安全风险。
          </p>
        </div>
      </div>
    </section>
  );
}